import React from 'react';
import './OtpBoxLogin.css';
import {connect} from 'react-redux';
import * as actionTypes from '../../../Action/Index';
import SweetAlert from './SweetAlert'

import Loader from 'react-loader-advanced';
import Spinner from 'react-bootstrap/Spinner'
class OtpBox extends React.Component{

    state = {
        length: 0,
        otp1:'',
        otp2:'',
        otp3:'',
        otp4:'',
      
    }

    emptyFields = () => {
        this.otp1.value = ''
        this.otp2.value = ''
        this.otp3.value = ''
        this.otp4.value = ''
    }
    emptystate=()=>{
        this.setState({length: 0,
            otp1:'',
            otp2:'',
            otp3:'',
            otp4:'',})
    }
    componentWillReceiveProps(nextProps){
         if(nextProps.mobileLastFourDigit!==""){
             this.setState({mobileLastFourDigit:nextProps.mobileLastFourDigit})
         }

        if(nextProps.OTPverified === 'NO' && this.state.otp1 !== ''){
            this.setState({
                otp1:'',
                otp2:'',
                otp3:'',
                otp4:'',
                length:0,
               
            })
            this.emptyFields()
        }
    }

    keyFinder = (keys)=>{
        if(keys===48){return 0}
        if(keys===49){return 1}
        if(keys===50){return 2}
        if(keys===51){return 3}
        if(keys===52){return 4}
        if(keys===53){return 5}
        if(keys===54){return 6}
        if(keys===55){return 7}
        if(keys===56){return 8}
        if(keys===57){return 9}
    }
    changeFocus = (e)=>{

        var value = this.keyFinder(e.keyCode)
        if(value===undefined && e.keyCode!==8){
          
            return
        }
            if(e.keyCode==8){
                        if(e.target.name === 'otp4'){
                            e.target.value = ''
                            if(this.state.length > 0)
                            this.setState({
                                length: this.state.length - 1,
                                otp4:""
                            },()=>this.otp3.focus())
                        }
                        if(e.target.name === 'otp3'){
                            e.target.value = ''
                            if(this.state.length > 0)
                            this.setState({
                                length: this.state.length - 1,
                                otp3:""
                            },()=>this.otp2.focus())
                            this.otp2.focus()
                        }
                        if(e.target.name === 'otp2'){
                            e.target.value = ''
                            if(this.state.length > 0)
                            this.setState({
                                length: this.state.length - 1,
                                otp2:""
                            },()=>this.otp1.focus())
                        }
                
                        if(e.target.name === 'otp1'){
                            e.target.value = ''
                            if(this.state.length > 0)
                            this.setState({
                                length: this.state.length - 1,
                                 otp1:""
                            })
                        }
            }
            if(e.keyCode!=8){ 
                    if(e.target.name === 'otp1'&& this.state.otp1===""){
                        this.setState({
                            length: this.state.length + 1,
                            otp1:value
                        },()=>{this.otp2.focus()})
                     }
                    if(e.target.name === 'otp2' && this.state.otp2===""){
                        this.otp3.focus()
                        this.setState({
                            length: this.state.length + 1,
                            otp2:value
                        })
                    }
                    if(e.target.name === 'otp3'&& this.state.otp3===""){
                        this.otp4.focus()
                        this.setState({
                            length: this.state.length + 1,
                            otp3:value
                        })
                    }
                    if(e.target.name === 'otp4'&& this.state.otp4===""){
                        this.setState({
                            length: this.state.length + 1,
                            otp4:value
                        })
                    }
                    if(e.target.name === 'otp1'&& this.state.otp1!==""){
                        this.setState({
                            length: this.state.length + 1,
                            otp2:value
                        },()=>this.otp2.focus())
                    }
                    if(e.target.name === 'otp2'&& this.state.otp2!==""){
                        this.setState({
                            length: this.state.length + 1,
                            otp3:value
                        },()=>this.otp3.focus())
                    }
                    if(e.target.name === 'otp3'&& this.state.otp3!==""){
                        this.setState({
                            length: this.state.length + 1,
                            otp4:value
                        },()=>this.otp4.focus())
                    }
            }
    }
    handleResend = () => {
        this.setState({
            resend: true
        })
    }
    sendOtp=()=>{
        let otp={
            o1:this.state.otp1,
            o2:this.state.otp2,
            o3:this.state.otp3,
            o4:this.state.otp4,
        }
      let arr=  Object.keys(otp).map((id)=>{
           return otp[id]
      })
      let str=arr.join("");
        this.props.verifyOtpMethode(this.props.email,str);
       
    }
   componentDidMount=()=>{
    this.props.resendOTP(this.props.email)
   }
   
 render(){
     
     if(this.props.open===true){
    return (
        this.props.verifyotpAtloginApiStatus ?<SweetAlert email={this.props.email}  ErrorCode={this.props.ErrorCode} closeModal={this.props.closeModal} type="success" show="true" msg="Mobile Verified Successfully"/>:
        <div className="otp-modal-form">
        <Loader show={this.props.resendotpLoader} message={ <Spinner animation="border" role="status"></Spinner> } style={{height:"auto"}}
        foregroundStyle={{color: '#fbb03b'}}
        backgroundStyle={{backgroundColor: '#F3EFEF'}}
        >
                <div className="" style={{width:'100%',display:'flex'}}>
                    <div className="modal-title">
                        <span style={{marginLeft:'62px'}}>Mobile Verification</span>
                    </div>
                   
                </div>
                 
                    <div className="success-msg">
                        <span>OTP has been sent to </span><span> ******{this.props.mobileLastFourDigit}</span>
                    </div>
                    <div className="success-msg">
                        <span style={{color:'red'}}>{this.props.err}</span>
                    </div>
                
                <div>    
                    <div style={{marginTop:"20px"}} className="modal-input">
                        <span className="">
                            <input 
                                type="text" 
                                name="otp1"
                                autoComplete='off'
                                
                                defaultValue={this.props.OTPverified === 'NO' ? '' : this.state.otp1}
                                ref={el => this.otp1 = el} 
                                onKeyUp={(e)=>this.changeFocus(e)}
                                maxLength="1"
                                style={{textAlign:'center',width:"30px"}}
                             />
                        </span>
                        <span className="">
                            <input 
                                type="text"  
                                name="otp2"
                                autoComplete='off'
                                defaultValue={this.props.OTPverified === 'NO' ? '' : this.state.otp2}
                                ref={el => this.otp2 = el} 
                                onKeyUp={(e)=>this.changeFocus(e)}
                                maxLength="1"
                                style={{textAlign:'center',width:"30px"}}/>
                        </span>
                        <span className="">
                            <input 
                                 type="text" 
                                 name="otp3"
                                 autoComplete='off'
                                 defaultValue={this.props.OTPverified === 'NO' ? '' : this.state.otp3}
                                 ref={el => this.otp3 = el} 
                                 onKeyUp={(e)=>this.changeFocus(e)}
                                 maxLength="1"
                                 style={{textAlign:'center',width:"30px"}}/>
                        </span>
                        <span className="">
                            <input 
                                type="text"  
                                name="otp4"
                                autoComplete='off'
                                defaultValue={this.props.OTPverified === 'NO' ? '' : this.state.otp4}
                                ref={el => this.otp4 = el} 
                                onKeyUp={(e)=>this.changeFocus(e)}
                                maxLength="1"
                                style={{textAlign:'center',width:"30px"}}/>
                        </span>
                    </div>
                    
                    
                   <span className="otpmessagelogin">{this.props.verifyotpAtloginApiStatus?null:this.props.verifyotpAtloginerrorMsg}</span>

                    <div className="resend" style={{width:'100%',textAlign:'center',marginTop:'40px'}}>
                    <button  style={{background:'white',color:'orange',height:32,width:'20%',borderRadius:20,marginLeft:168,border:"1px solid orange",fontWeight:"bold"}}
                    onClick={()=>this.props.closeModal()}
                    >Back</button>
                   
                    <button  style={{background:'#fbb03b',color:'#fff',height:32,width:'20%',borderRadius:20,marginLeft:23,border:"none" ,fontWeight:"bold"}} disabled={this.state.length === 4 ? false : true} onClick={()=>this.sendOtp()}>Verify</button>
                    <span className="verifyspinner">{this.props.verifyotpAtloginLoader?<Spinner animation="border" variant="warning" />:null}</span>
                    <br/>
                        <div style={{marginTop:"25px"}} className="resendVerify">Didn't receive an OTP? <span style={{color:'#fbb03b',cursor:'pointer',fontWeight:"bold"}} onClick={()=>this.props.resendOTP(this.props.email)}>Resend</span></div>
                    </div>
                </div>
             </Loader>
        </div>
  )
    }else{
        return null;
    }
 }
  
}


const mapStateToProps = state => {
    return{
        verifyotpAtloginLoader:state.employeeReducer.verifyotpAtloginLoader,
        verifyotpAtloginApiStatus:state.employeeReducer.verifyotpAtloginApiStatus,
        verifyotpAtloginNetworkError:state.employeeReducer.verifyotpAtloginNetworkError,
        verifyotpAtloginerrorMsg:state.employeeReducer.verifyotpAtloginerrorMsg,
     resendotpLoader:state.employeeReducer.resendotpLoader,
     otpSent:state.employeeReducer.otpSent,
     mobileLastFourDigit:state.employeeReducer.mobileLastFourDigit,
     resendotpApiStatus:state.employeeReducer.resendotpApiStatus,
     resentNetworkError:state.employeeReducer.resentNetworkError,
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return{
        verifyOtpMethode: (email,data) => dispatch(actionTypes.verifyOtpAtlogin(email,data)),
        resendOTP:(email)=>dispatch(actionTypes.resendOTP(email)),
        clearLoginState:()=>dispatch(actionTypes.clearLoginState())
    }
  }
  
export default connect(mapStateToProps,mapDispatchToProps)(OtpBox);